<template>
	<main>
		<header class="flex justify-between w-full items-center mb-4">
			<h5 class="mr-6"><strong class="text-primary">Sahabat ZX Pilihan</strong></h5>
			<router-link to="/mitra/choice" class="text-primary">
				
			</router-link>
		</header>

		<section>
			<swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
				<swiper-slide
					v-for="(item, i) in mitra"
					:key="i"
				>
					<vx-card class="mb-4 py-3">
						<router-link :to="`/sahabat-zx/${createSlugLink( (item.user ? item.user.name : item.name), item.id )}`">

							<div class="vx-row items-center">
								<div class="vx-col w-full mb-6" style="height: 3rem;overflow: auto;">
									<img v-if="item.user && item.user.file !== null" v-lazy="item.user.file" class="w-12 mx-auto rounded-full" alt="" />
									<img v-else v-lazy="`/assets/images/sahabat-zx/charity.svg`" class="w-12 mx-auto rounded-full" alt="" />
								</div>
								<div class="vx-col w-full">
									<h4 class="text-center" style="height: 3rem;overflow: auto;"><strong class="text-primary">{{item.user ? item.user.name : item.name}}</strong></h4>
								</div>
							</div>

						</router-link>
					</vx-card>
				</swiper-slide>

				<div class="swiper-button-next swiper-button-black" slot="button-next"></div>
	            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</section>
	</main>
</template>
<script>
	import 'swiper/dist/css/swiper.min.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

	export default {
		components: {
			swiper,
			swiperSlide
		},
		data: () => ({
			mitra: [],
			swiperOption: {
		        slidesPerView: 4,
		    	spaceBetween: 30,
		    	breakpoints: {
					1440: {
						slidesPerView: 4,
						spaceBetween: 40
					},
		        	1024: {
		          		slidesPerView: 3,
		          		spaceBetween: 40
		        	},
		        	768: {
		          		slidesPerView: 2,
		          		spaceBetween: 30
		        	},
		        	640: {
		          		slidesPerView: 1,
		          		spaceBetween: 20
		        	}
		      },
		    	navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			}
		}),
		methods: {
			getData() {
				const params = {
					start: 0,
					status_lembaga: 1,
					status: 1
				}

				this.$store.dispatch('mitra/getChoiceMitra', params)
				.then(data => {
					this.mitra = data.data
				})
				.catch(e => {
					if(e.response) {
						console.error(e.response)
					}

					return false
				})
			}
		},
		created() {
			this.getData()
		}
	}
</script>